export default __webpack_public_path__ + "static/media/COVID-Icons-2.3466363a.svg";